import axios from 'axios';

import type { FleetRef, FleetStartVerificationRequest } from '../domain/fleet-verification';

const getFleetRefs: () => Promise<FleetRef[]> = () =>
  axios.get<FleetRef[]>('/qualification/fleet-verification/fleets').then((response) => response.data);

const startVerification: (payload: FleetStartVerificationRequest) => Promise<void> = (payload) =>
  axios.post('/qualification/fleet-verification/start-verification', payload);

export { getFleetRefs, startVerification };
